import Vue from "vue";
import { checkDomainRedirect } from "../utils/domain";
import VueRouter from "vue-router";
import store from "../store";


Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/Login.vue"),
    meta: { public: true },
  },
  {
    path: "/okx-desk",
    name: "OkxDesk",
    component: () => import("../views/risk/OkxDesk.vue"),
    meta: { public: true },
  },
  {
    path: "/channel/register/:linkCode",
    name: "ChannelRegister",
    component: () => import("../views/ChannelRegister.vue"),
    meta: { public: true },
  },
  {
    path: "/channel/supplement/:channelUserId",
    name: "ChannelSupplement",
    component: () => import("../views/ChannelSupplement.vue"),
    meta: { public: true },
  },
  {
    path: "/supplement/:id",
    name: "Supplement",
    component: () => import("../views/Supplement.vue"),
    meta: { public: true },
  },
  {
    path: "/ai-chat/:linkCode",
    name: "AiChatRoom",
    component: () => import("../views/AiChatRoom.vue"),
    meta: { public: true },
  },
  {
    path: "/application-status",
    name: "ApplicationStatus",
    component: () => import("../views/ApplicationStatus.vue"),
    meta: { public: true },
  },
  {
    path: "/",
    name: "Layout",
    component: () => import("../views/Layout.vue"),
    redirect: "/dashboard",
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        component: () => import("../views/Dashboard.vue"),
        meta: { title: "数据概览", icon: "el-icon-s-data", adminOnly: true },
      },
      {
        path: "users",
        name: "Users",
        component: () => import("../views/Users.vue"),
        meta: { title: "渠道用户管理", icon: "el-icon-user" },
      },
      {
        path: "user/detail/:id",
        name: "UserDetail",
        component: () => import("../views/UserDetail.vue"),
        meta: { title: "用户详情", icon: "el-icon-user", hidden: true },
      },
      {
        path: "channel",
        name: "Channel",
        component: () => import("../views/Channel.vue"),
        meta: { title: "渠道管理", icon: "el-icon-share" },
      },
      {
        path: "ai-chat",
        name: "AiChat",
        component: () => import("../views/AiChat.vue"),
        meta: { title: "AI对话", icon: "el-icon-chat-dot-round" },
      },
      {
        path: "ai-chat-sessions",
        name: "AiChatSessions",
        component: () => import("../views/AiChatSessions.vue"),
        meta: { title: "对话管理", icon: "el-icon-chat-line-round" },
      },
      {
        path: "ai-chat-admin/:sessionId",
        name: "AiChatAdmin",
        component: () => import("../views/AiChatAdmin.vue"),
        meta: { title: "客服对话", hidden: true },
      },
      {
        path: "complaint",
        name: "ComplaintManage",
        component: () => import("../views/ComplaintManage.vue"),
        meta: { title: "投诉建议", icon: "el-icon-s-comment" },
      },
      {
        path: "auth-letter",
        name: "AuthLetterManage",
        component: () => import("../views/AuthLetterManage.vue"),
        meta: { title: "授权书查询", icon: "el-icon-document-checked" },
      },
      {
        path: "ad-track",
        name: "AdTrack",
        component: () => import("../views/AdTrack.vue"),
        meta: { title: "广点通对接", icon: "el-icon-connection" },
      },
      {
        path: "push-log",
        name: "PushLog",
        component: () => import("../views/PushLog.vue"),
        meta: { title: "推送记录", icon: "el-icon-position" },
      },
      {
        path: "lead-pool",
        name: "LeadPool",
        component: () => import("../views/LeadPool.vue"),
        meta: { title: "线索池", icon: "el-icon-files" },
      },
      {
        path: "dedup-pack",
        name: "DedupPack",
        component: () => import("../views/DedupPack.vue"),
        meta: { title: "排重包管理", icon: "el-icon-copy-document" },
      },
      {
        path: "product",
        name: "Product",
        component: () => import("../views/Product.vue"),
        meta: { title: "商品管理", icon: "el-icon-goods" },
      },
      {
        path: "document",
        name: "Document",
        component: () => import("../views/Document.vue"),
        meta: { title: "资料管理", icon: "el-icon-folder-opened" },
      },
      {
        path: "loan-order",
        name: "LoanOrder",
        component: () => import("../views/LoanOrder.vue"),
        meta: { title: "订单管理", icon: "el-icon-s-order" },
      },
      {
        path: "loan-order/detail/:id",
        name: "LoanOrderDetail",
        component: () => import("../views/LoanOrderDetail.vue"),
        meta: { title: "订单详情", icon: "el-icon-document" },
        hidden: true
      },
      {
        path: "iou",
        name: "IouContract",
        component: () => import("../views/IouContract.vue"),
        meta: { title: "打借条", icon: "el-icon-edit-outline" },
      },
      {
        path: "iou/template",
        name: "IouTemplate",
        component: () => import("../views/IouTemplate.vue"),
        meta: { title: "合同模板", icon: "el-icon-document-copy" },
      },
      {
        path: "iou/lender",
        name: "IouLender",
        component: () => import("../views/IouLender.vue"),
        meta: { title: "甲方设置", icon: "el-icon-s-custom" },
      },
      {
        path: "agreement",
        name: "AgreementManage",
        component: () => import("../views/AgreementManage.vue"),
        meta: { title: "协议管理", icon: "el-icon-document" },
      },
      {
        path: "repayment",
        name: "Repayment",
        component: () => import("../views/PendingPayment.vue"),
        meta: { title: "待付款", icon: "el-icon-wallet" },
      },
      {
        path: "finance/gold-price",
        name: "GoldPrice",
        component: () => import("../views/GoldPriceManage.vue"),
        meta: { title: "黄金金价管理", icon: "el-icon-coin", adminOnly: true },
      },
      {
        path: "finance/gold-shipment",
        name: "GoldShipment",
        component: () => import("../views/GoldShipment.vue"),
        meta: { title: "黄金发货统计", icon: "el-icon-s-order", adminOnly: true },
      },
      {
        path: "finance/gold-purchase",
        name: "GoldPurchase",
        component: () => import("../views/GoldPurchase.vue"),
        meta: { title: "黄金仓库管理", icon: "el-icon-box", adminOnly: true },
      },
      {
        path: "sms/template",
        name: "SmsTemplate",
        component: () => import("../views/SmsTemplate.vue"),
        meta: { title: "短信模板设置", icon: "el-icon-message", adminOnly: true },
      },
      {
        path: "profile",
        name: "Profile",
        component: () => import("../views/Profile.vue"),
        meta: { title: "个人中心", icon: "el-icon-setting", hidden: true },
      },
      {
        path: "ai-chat-stats",
        name: "AiChatStats",
        component: () => import("../views/AiChatStats.vue"),
        meta: { title: "对话统计", icon: "el-icon-s-data" },
      },
      {
        path: "ai-screen",
        name: "AiScreen",
        component: () => import("../views/AiScreen.vue"),
        meta: { title: "数据大屏", icon: "el-icon-monitor" },
      },
      {
        path: "system/oplog",
        name: "OpLog",
        component: () => import("../views/OpLog.vue"),
        meta: { title: "操作日志", icon: "el-icon-document", adminOnly: true },
      },
      {
        path: "ai-keywords",
        name: "AiKeywords",
        component: () => import("../views/AiKeywords.vue"),
        meta: { title: "关键词优化", icon: "el-icon-key", adminOnly: true },
      },
      {
        path: "ai-learn",
        name: "AiLearn",
        component: () => import("../views/AiLearn.vue"),
        meta: { title: "智能学习", icon: "el-icon-cpu" },
      },
      {
        path: "ai-agents",
        name: "Agents",
        component: () => import("../views/Agents.vue"),
        meta: { title: "坐席管理", icon: "el-icon-service" },
      },
      {
        path: "domain",
        name: "DomainManage",
        component: () => import("../views/DomainManage.vue"),
        meta: { title: "域名管理", icon: "el-icon-link", adminOnly: true },
      },
      {
        path: "system/role",
        name: "RoleManage",
        component: () => import("../views/RoleManage.vue"),
        meta: { title: "角色管理", icon: "el-icon-s-custom", adminOnly: true },
      },
      {
        path: "system/permission",
        name: "PermissionManage",
        component: () => import("../views/system/PermissionManage.vue"),
        meta: { title: "权限管理", icon: "el-icon-lock", adminOnly: true },
      },
      {
        path: "system/user",
        name: "SysUserManage",
        component: () => import("../views/system/SysUser.vue"),
        meta: { title: "管理员管理", icon: "el-icon-s-custom", adminOnly: true },
      },
      {
        path: "risk/api-key-config",
        name: "ApiKeyConfig",
        component: () => import("../views/risk/ApiKeyConfig.vue"),
        meta: { title: "密钥管理", icon: "el-icon-key", adminOnly: true },
      },
      {
        path: "risk/model",
        name: "RiskModel",
        component: () => import("../views/risk/RiskModel.vue"),
        meta: { title: "风控模型", icon: "el-icon-set-up", adminOnly: true },
      },
      {
        path: "risk/query",
        name: "RiskQuery",
        component: () => import("../views/risk/RiskQuery.vue"),
        meta: { title: "风控查询", icon: "el-icon-search", adminOnly: true },
      },
      {
        path: "risk/api-doc",
        name: "RiskApiDoc",
        component: () => import("../views/risk/RiskApiDoc.vue"),
        meta: { title: "对接文档", icon: "el-icon-document", adminOnly: true },
      },
      {
        path: "okx/cockpit",
        name: "OkxCockpit",
        component: () => import("../views/risk/OkxCockpit.vue"),
        meta: { title: "OKX驾驶舱", icon: "el-icon-cpu", adminOnly: true },
      },
      {
        path: "okx/dashboard",
        name: "OkxDashboard",
        component: () => import("../views/risk/OkxDashboard.vue"),
        meta: { title: "OKX数据面板", icon: "el-icon-data-analysis", adminOnly: true },
      },
      {
        path: "okx/risk",
        name: "OkxRisk",
        component: () => import("../views/risk/OkxRisk.vue"),
        meta: { title: "OKX风控与下单", icon: "el-icon-odometer", adminOnly: true },
      },
      {
        path: "okx/review",
        name: "OkxReview",
        component: () => import("../views/risk/OkxReview.vue"),
        meta: { title: "OKX复盘功能", icon: "el-icon-document-checked", adminOnly: true },
      },
      {
        path: "okx/backtest",
        name: "OkxBacktest",
        component: () => import("../views/risk/OkxBacktest.vue"),
        meta: { title: "OKX回测数据学习", icon: "el-icon-data-analysis", adminOnly: true },
      },
      {
        path: "okx/finance",
        name: "OkxFinance",
        component: () => import("../views/risk/OkxFinance.vue"),
        meta: { title: "OKX财务对账", icon: "el-icon-s-finance", adminOnly: true },
      },
      {
        path: "okx/users",
        name: "OkxUsers",
        component: () => import("../views/risk/OkxUsers.vue"),
        meta: { title: "OKX注册用户", icon: "el-icon-user", adminOnly: true },
      },
      {
        path: "okx/selfai",
        name: "OkxSelfAi",
        component: () => import("../views/risk/OkxSelfAi.vue"),
        meta: { title: "自研AI审核", icon: "el-icon-cpu", adminOnly: true },
      },
      {
        path: "okx/versions",
        name: "OkxVersions",
        component: () => import("../views/risk/OkxVersions.vue"),
        meta: { title: "OKX参数版本", icon: "el-icon-collection-tag", adminOnly: true },
      },
      {
        path: "okx/env",
        name: "OkxEnv",
        component: () => import("../views/risk/OkxEnv.vue"),
        meta: { title: "OKX环境与基础", icon: "el-icon-connection", adminOnly: true },
      },
    ],
  },
  // 借条公开签署页必须放在 Layout 之后，否则会抢占 /iou/template、/iou/lender 等后台路由
  {
    path: "/iou/view/:viewCode",
    name: "IouView",
    component: () => import("../views/IouView.vue"),
    meta: { title: "借条合同查看", public: true },
  },
  {
    path: "/iou/:linkCode",
    name: "IouSign",
    component: () => import("../views/IouSign.vue"),
    meta: { public: true },
  },
  { path: "*", redirect: "/" },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  // 防封双层域名：首次加载检查是否需要从分享域(A)跳转到落地域(B)
  await checkDomainRedirect();

  const token = localStorage.getItem("token") || "";
  const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
  const userType = userInfo.userType;
  const roleCode = userInfo.roleCode;

  if (to.meta && to.meta.public) {
    next();
    return;
  }

  if (!token) {
    next("/login");
    return;
  }

  if (to.meta && to.meta.adminOnly && userType !== 0 && roleCode !== "ADMIN") {
    next(userInfo.dataScope === 1 ? "/dashboard" : "/ai-chat");
    return;
  }

  next();
});

// 统一设置浏览器/小程序 web-view 标题：H5聊天页由页面内按场景名设置，后台各页带「系统管理」后缀
router.afterEach((to) => {
  if (to.name === "AiChatRoom") return;
  if (to.name === "Login") {
    document.title = "系统管理";
    return;
  }
  if (to.meta && to.meta.public) {
    document.title = to.meta.title || "贷款咨询";
    return;
  }
  document.title = to.meta && to.meta.title ? `${to.meta.title} - 系统管理` : "系统管理";
});

export default router;






